module.exports = __webpack_public_path__ + "img/daily_specials_3.1c0683f6.jpg";